import React from 'react';

import {gt} from 'app/utils/i18n';

import {BaseTour, TourStep} from './BaseTour';

const steps: Array<TourStep<number>> = [
  {
    role: 'any',
    title: gt('This is a Procedure'),
    content: gt('Here is a quick tour to show you around the Procedure view.'),
    target: 'body',
    placement: 'center',
  },
  {
    role: 'any',
    title: gt('The Procedure Title'),
    content: gt('Here is the title and overview of this procedure.'),
    target: '#document-head .container',
  },
  {
    role: 'any',
    title: gt('The First Step'),
    content: gt(
      'Here is the first step in this procedure.  Steps can include descriptions, images, files, and/or video.'
    ),
    target: '.js-document-body ol li',
    condition: (numSteps) => numSteps > 0,
  },
  {
    role: 'any',
    title: gt('Check off steps, record your progress'),
    content: (
      <div>
        <b>{gt('Click start')}</b>,{' '}
        {gt(
          'and the person following this procedure can check off each step as they are completed.'
        )}
      </div>
    ),
    target: '#document-head .js-start-task',
  },
  {
    role: 'manager',
    title: gt('Anyone can edit'),
    content: gt(
      'Need to edit this procedure?  Click this button to enter editing mode, where you can make changes. You must approve changes before they go live.'
    ),
    target: '.action-area .tour-edit',
    spotlightPadding: 2,
  },
  {
    role: 'teammate',
    title: gt('Anyone can edit'),
    content: gt(
      'Need to edit this procedure?  Click this button to enter editing mode, where you can make changes. A manager must approve your changes before they go live.'
    ),
    target: '.action-area .tour-edit',
    spotlightPadding: 2,
  },
  {
    role: 'any',
    title: gt('Go Back to the Dashboard'),
    content: gt(
      'Finished viewing this procedure?  Click here to go back to the dashboard, where you can see your list of all procedures.'
    ),
    target: '.breadcrumb .breadcrumb-item:first-child',
  },
  {
    role: 'any',
    title: gt("That's all for now..."),
    content: (
      <div>
        {gt('This concludes your tour of the Procedure view.')}
        <h3 className="my-2" style={{fontSize: 18}}>
          {gt('Where to from here?')}
        </h3>
        {gt(
          'You can go ahead start the procedure and check off a few steps, edit this procedure, leave a comment, or go back to the dashboard.'
        )}
      </div>
    ),
    target: 'body',
    placement: 'center',
  },
];

interface Props {
  additionalData: number;
}

export const ProcedureDetailTour = ({additionalData}: Props): JSX.Element => (
  <BaseTour steps={steps} tourname="view" additionalData={additionalData} />
);
